/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { VersionsDto } from '../models/VersionsDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class VersionService {

    /**
     * @returns VersionsDto Successfully fetch versions
     * @throws ApiError
     */
    public static getVersions(): CancelablePromise<VersionsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/versions',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

}
